import { getProductionEnvironment } from './all-environments-config.model';

export const environment = {
  production: true,
  baseTitle: 'Streaker Central',
  environmentMessage: '',

  environment: getProductionEnvironment(window.location.hostname),

  allowConfiguration: true,
  enabledConsoleLogging: false,

  googleAnalyticsTrackingToken: null,
  showContactUs: false,
  contactUsEmail: 'support@holidaystreakers.com',
  disabledUserInactvityTimeout: true
};
